import angular from 'angular';
import UIRouter from 'angular-ui-router';

import './styles/index.scss';
import template from './index.html';
import HomeworkController from './HomeworkController';

    
let namespace = angular.module('olr-mainfe-homework', [
  UIRouter,
  'olr-common'
]);

namespace.config(function($stateProvider) {
  $stateProvider.state('olr.mainfe.homework', {
    url: '/homework',
    controller: HomeworkController,
    controllerAs: 'hwCtrl',
    template: template
  });
});

namespace.controller('HomeworkController', HomeworkController);

export default namespace.name;





/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-homework/index.js
 **/